// Javascript for BAS/BannerDynLandscape

// You can remove this line safely!
var app = "BAS/BannerDynLandscape";